import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleGoToLogin = () => {
    navigate('/login')
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      backgroundColor: '#f8fafc',
      padding: '2rem',
      textAlign: 'center'
    }}>
      {/* Animated 404 */}
      <div style={{
        position: 'relative',
        marginBottom: '2rem'
      }}>
        <h1 style={{
          fontSize: '8rem',
          fontWeight: '900',
          color: '#e2e8f0',
          margin: '0',
          lineHeight: '1',
          textShadow: '0 0 20px rgba(0,0,0,0.1)',
          animation: 'pulse 2s infinite'
        }}>
          404
        </h1>
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60px',
          height: '60px',
          backgroundColor: '#3b82f6',
          borderRadius: '50%',
          opacity: '0.1',
          animation: 'bounce 2s infinite'
        }} />
      </div>

      {/* Content */}
      <div style={{ maxWidth: '500px', marginBottom: '3rem' }}>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '700',
          color: '#1e293b',
          margin: '0 0 1rem 0',
          lineHeight: '1.2'
        }}>
          Oops! Page Not Found
        </h2>
        <p style={{
          fontSize: '1.125rem',
          color: '#64748b',
          margin: '0 0 2rem 0',
          lineHeight: '1.6'
        }}>
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back on track!
        </p>
      </div>

      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        <button 
          onClick={handleGoToLogin}
          style={{
            padding: '0.875rem 2rem',
            backgroundColor: '#3b82f6',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '0.5rem',
            fontSize: '1rem',
            fontWeight: '600',
            transition: 'all 0.2s ease',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            border: 'none',
            cursor: 'pointer'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#2563eb'
            e.target.style.transform = 'translateY(-1px)'
            e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#3b82f6'
            e.target.style.transform = 'translateY(0)'
            e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }}
        >
          Go to Login
        </button>
        <button 
          onClick={handleGoBack}
          style={{
            padding: '0.875rem 2rem',
            backgroundColor: 'white',
            color: '#374151',
            textDecoration: 'none',
            borderRadius: '0.5rem',
            fontSize: '1rem',
            fontWeight: '600',
            border: '2px solid #e5e7eb',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f9fafb'
            e.target.style.borderColor = '#d1d5db'
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'white'
            e.target.style.borderColor = '#e5e7eb'
          }}
        >
          Go Back
        </button>
      </div>

      {/* Decorative Elements */}
      <div style={{
        position: 'absolute',
        top: '20%',
        left: '10%',
        width: '100px',
        height: '100px',
        backgroundColor: '#dbeafe',
        borderRadius: '50%',
        opacity: '0.3',
        animation: 'float 6s ease-in-out infinite'
      }} />
      <div style={{
        position: 'absolute',
        top: '60%',
        right: '10%',
        width: '60px',
        height: '60px',
        backgroundColor: '#fef3c7',
        borderRadius: '50%',
        opacity: '0.4',
        animation: 'float 4s ease-in-out infinite reverse'
      }} />
      <div style={{
        position: 'absolute',
        bottom: '20%',
        left: '20%',
        width: '80px',
        height: '80px',
        backgroundColor: '#fce7f3',
        borderRadius: '50%',
        opacity: '0.3',
        animation: 'float 5s ease-in-out infinite'
      }} />

      {/* CSS Animations */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
        @keyframes bounce {
          0%, 100% { transform: translate(-50%, -50%) scale(1); }
          50% { transform: translate(-50%, -50%) scale(1.1); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </div>
  )
}

export default NotFound
